module.exports = __webpack_public_path__ + "media/customizations/montaneranch/logo-b3eec0173b3c6892c19fa646824fd452.png";